module.exports = __webpack_public_path__ + "f12774a7c3d208109ba57380c8dd3ae6.png";